// Finished and running print jobs survive a reload: stored in IndexedDB (one record
// per job, the events as stream bytes). Browsers do not sync it between devices.
import { run } from './db.js';
import { jobFromRecord, jobToRecord } from './jobs.js';

export function openJobStore(opened) {
  return {
    async loadAll() {
      const recs = await run(opened, 'jobs', 'readonly', (s) => s.getAll());
      return recs.map(jobFromRecord);
    },
    save: (job) => run(opened, 'jobs', 'readwrite', (s) => s.put(jobToRecord(job))),
    remove: (ids) => run(opened, 'jobs', 'readwrite', (s) => ids.forEach((id) => s.delete(id))),
    clear: () => run(opened, 'jobs', 'readwrite', (s) => s.clear()),
  };
}
